// navigation-direction-context.tsx
import React, { createContext, useContext, useState } from "react";

export type NavigationDirection = "forward" | "backward";

interface NavigationDirectionContextValue {
    direction: NavigationDirection;
    setDirection: (dir: NavigationDirection) => void;
}

const NavigationDirectionContext =
    createContext<NavigationDirectionContextValue | undefined>(undefined);

export const NavigationDirectionProvider: React.FC<
    React.PropsWithChildren<{}>
> = ({ children }) => {
    const [direction, setDirection] =
        useState<NavigationDirection>("forward");
    return (
        <NavigationDirectionContext.Provider value={{ direction, setDirection }}>
            {children}
        </NavigationDirectionContext.Provider>
    );
};

export const useNavigationDirection = () => {
    const ctx = useContext(NavigationDirectionContext);
    if (!ctx)
        throw new Error(
            "useNavigationDirection must be used inside NavigationDirectionProvider"
        );
    return ctx;
};
